/* 🤖 this file was generated by svg-to-ts */
export const matIconAccountBalanceWallet: {
  name: 'account-balance-wallet';
  data: string;
} = {
  name: 'account-balance-wallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 7.28V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0 0 22 15V9a2 2 0 0 0-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"/><circle cx="16" cy="12" r="1.5"/></svg>`
};
